import { alpha } from '@mui/material';
import { green, grey } from './colors';
export const action = (mode)=>{
    const hover = alpha(grey[300], 0.2);
    const selected = alpha(grey[300], 0.35);
    return mode === 'light' ? {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.5),
        disabled: alpha(grey[500], 0.6),
        menuSelected: green[50]
    } : {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.35),
        disabled: alpha(grey[300], 0.5),
        menuSelected: green[800]
    };
};

//# sourceMappingURL=action.js.map